import { useEffect } from 'react'
import { createPortal } from 'react-dom'

import { isSignedIn } from 'utils/userAuth'

import { usePaywallStore } from '../stores/paywall'

import PaywallModal from './paywall-modal'

export const PaywallPortal = () => {
  const {
    isOpen,
    type,
    descriptionVariable,
    closePaywall,
    handleUpgrade,
    handleStartTrial,
    handleClickLink,
  } = usePaywallStore()

  useEffect(() => {
    if (!document.getElementById('paywall-modal-root')) {
      const div = document.createElement('div')
      div.id = 'paywall-modal-root'
      document.body.appendChild(div)
    }
  }, [])

  const modalRoot = document.getElementById('paywall-modal-root')
  if (!modalRoot || !type) return null

  return createPortal(
    <PaywallModal
      isOpen={isOpen}
      type={type}
      descriptionVariable={descriptionVariable}
      onClose={closePaywall}
      onClickPrimary={isSignedIn() ? handleUpgrade : handleStartTrial}
      onClickLink={handleClickLink}
    />,
    modalRoot,
  )
}

export default PaywallPortal
